import * as ct from 'countries-and-timezones';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// load ISO country data
countries.registerLocale(enLocale);

/**
 * Convert a timezone string (e.g. "Africa/Cairo") to ISO-3 country code.
 */
function timezoneToIso3(timezone: string): string | null {
  const country = ct.getCountryForTimezone(timezone);
  if (!country) return null;
  return countries.alpha2ToAlpha3(country.id) || null;
}

/**
 * Aggregate user counts by country.
 * - Converts timezones to ISO-3 country codes
 * - Sums counts if multiple timezones belong to the same country
 * - Groups unknown/UTC into "UNK"
 */
export function aggregateUsersByCountry(
  rawData: Record<string, number>
): Record<string, number> {
  const result: Record<string, number> = {};

  Object.entries(rawData).forEach(([tz, count]) => {
    const iso3 = timezoneToIso3(tz);
    if (iso3) {
      result[iso3] = (result[iso3] || 0) + count;
    } else {
      result['UNK'] = (result['UNK'] || 0) + count;
    }
  });

  return result;
}
